/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CommentsResponse,
  DownloadDocumentResponse,
  ErrorResponseDto,
  ExportInvoicesParams,
  GetInvoiceCommentsParams,
  GetInvoiceDetailParams,
  GetInvoicesCountParams,
  GetInvoicesIdsParams,
  GetInvoicesOverviewParams,
  InvoiceDetail,
  InvoiceIdPaginatedDto,
  InvoiceOverviewPaginatedDto,
  TotalCountDto,
} from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class Invoices<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Invoices
   * @name ExportInvoices
   * @summary Export all invoices
   * @request GET:/v1/invoices/export
   * @response `200` `DownloadDocumentResponse`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  exportInvoices = (query: ExportInvoicesParams, params: RequestParams = {}) =>
    this.http.request<DownloadDocumentResponse, ErrorResponseDto>({
      path: `/v1/invoices/export`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Invoices
   * @name GetInvoiceComments
   * @summary Get invoice comments
   * @request GET:/v1/invoices/{id}/comments/{shipmentId}
   * @response `200` `CommentsResponse`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getInvoiceComments = ({ id, shipmentId, ...query }: GetInvoiceCommentsParams, params: RequestParams = {}) =>
    this.http.request<CommentsResponse, ErrorResponseDto>({
      path: `/v1/invoices/${id}/comments/${shipmentId}`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Invoices
   * @name GetInvoiceDetail
   * @summary Get invoice detail
   * @request GET:/v1/invoices/{id}
   * @response `200` `InvoiceDetail`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getInvoiceDetail = ({ id, ...query }: GetInvoiceDetailParams, params: RequestParams = {}) =>
    this.http.request<InvoiceDetail, ErrorResponseDto>({
      path: `/v1/invoices/${id}`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Invoices
   * @name GetInvoicesCount
   * @summary Get invoices count
   * @request GET:/v1/invoices/count
   * @response `200` `TotalCountDto`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getInvoicesCount = (query: GetInvoicesCountParams, params: RequestParams = {}) =>
    this.http.request<TotalCountDto, ErrorResponseDto>({
      path: `/v1/invoices/count`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Invoices
   * @name GetInvoicesIds
   * @summary Get invoices ids
   * @request GET:/v1/invoices/ids
   * @response `200` `InvoiceIdPaginatedDto`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getInvoicesIds = (query: GetInvoicesIdsParams, params: RequestParams = {}) =>
    this.http.request<InvoiceIdPaginatedDto, ErrorResponseDto>({
      path: `/v1/invoices/ids`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Invoices
   * @name GetInvoicesOverview
   * @summary Get all invoices
   * @request GET:/v1/invoices
   * @response `200` `InvoiceOverviewPaginatedDto`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getInvoicesOverview = (query: GetInvoicesOverviewParams, params: RequestParams = {}) =>
    this.http.request<InvoiceOverviewPaginatedDto, ErrorResponseDto>({
      path: `/v1/invoices`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
}
